import { Modal } from 'antd';

const Confirm = ({ open, hideModal, proceedButton, okText, cancelText }: any) => {

    return (
        <Modal
            title="Logout"
            open={open}
            onOk={proceedButton}
            onCancel={hideModal}
            okText={okText}
            cancelText={cancelText}
        >
            <p>Are you sure, you want to logout?</p>
        </Modal>
    );
};

export { Confirm };
